'use client';

import { useEffect, useState } from 'react';

interface CopyTextButtonProps {
  label: string;
  value: string;
}

export default function CopyTextButton({ label, value }: Readonly<CopyTextButtonProps>) {
  const [status, setStatus] = useState<'idle' | 'copied' | 'error'>('idle');

  useEffect(() => {
    if (status === 'idle') return;

    const timer = window.setTimeout(() => setStatus('idle'), 3000);
    return () => window.clearTimeout(timer);
  }, [status]);

  const copyValue = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setStatus('copied');
    } catch {
      setStatus('error');
    }
  };

  return (
    <span className="relative inline-flex items-baseline">
      <button
        type="button"
        onClick={copyValue}
        aria-label={`Copier ${value}`}
        className="text-red cursor-copy border-0 bg-transparent p-0 font-black underline decoration-2 underline-offset-4 transition-colors hover:text-red-700"
      >
        {label}
      </button>

      {status !== 'idle' && (
        <span
          role="status"
          aria-live="polite"
          className="absolute top-full left-0 z-50 mt-2 rounded-full bg-gray-950 px-3 py-1.5 text-xs font-bold whitespace-nowrap text-white shadow-lg sm:top-1/2 sm:left-full sm:mt-0 sm:ml-3 sm:-translate-y-1/2"
        >
          {status === 'copied' ? 'Adresse copiée' : 'Impossible de copier l’adresse'}
        </span>
      )}
    </span>
  );
}
